/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { MdAccessTime } from 'react-icons/md';
import PropTypes from 'prop-types';
import './SelectedFlightDetails.scss';
import {
  formatDate,
  formatTimeString,
  convertTravelTime,
  getConnectingTime,
  getFlightNumberForAgent,
  getCabinBaggage,
  getTerminalNumber,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import { getAirportNameByCode } from '../../shared/constants/AirportsName';
import { DAY_DATE_MONTH_YEAR_VIEW_FORMAT } from '../../shared/constants/Constants';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';

function SelectedFlightDetails({ selectedFlight, selectedFare, isOnward }) {
  const [showTransitInfo, setShowTransitInfo] = useState(false);

  const getTransitVisaInfo = () => {
    let hasVisaInfo = false;
    selectedFlight.flightlegs.forEach((leg) => {
      if (
        leg.transitvisainfo &&
        leg.transitvisainfo !== '' &&
        leg.transitvisainfo !== null
      ) {
        hasVisaInfo = true;
      }
    });
    setShowTransitInfo(hasVisaInfo);
  };

  useEffect(() => {
    getTransitVisaInfo();
  }, []);

  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  const { flightlegs } = selectedFlight;

  const getFlightNumber = (fltNumber, index) => {
    if (selectedFare) {
      if (isOnward) {
        return getFlightNumberForAgent(
          selectedFare.flightCarrier[index],
          fltNumber,
        );
      }
      return getFlightNumberForAgent(
        selectedFare.flightCarrierReturn[index],
        fltNumber,
      );
    }
    return getFlightNumberForAgent(flightlegs[0].carrier, fltNumber);
  };

  const getFlightBaggage = (weight, unit, index) => {
    if (selectedFare) {
      if (isOnward) {
        return getCabinBaggage(
          selectedFare.flightBagWeight[index],
          selectedFare.flightBagUnit[index],
        );
      }
      return getCabinBaggage(
        selectedFare.flightBagWeightReturn[index],
        selectedFare.flightBagUnitReturn[index],
      );
    }
    return getCabinBaggage(weight, unit);
  };

  const getBookingClass = (classText, index) => {
    if (selectedFare) {
      if (isOnward) {
        return selectedFare.bookingClass[index];
      }
      return selectedFare.returnBookingClass[index];
    }
    return classText;
  };
  const getOperatedBy = (flt) => {
    if (flt.operatedby !== '' && flt.operatedby !== ',') {
      return `${' '}Operated by: ${flt.operatedby}`;
    }
    return '';
  };
  return (
    <section className="selected-flight-details selectedFlightDetails">
      {flightlegs.map((flightLeg, index) => {
        const finalDestination = flightlegs[flightlegs.length - 1].destination;
        return (
          <div
            key={`${flightLeg.carrier}_${flightLeg.flightnumber}`}
            className="selected-flight-details__flight-leg selectedFlightLegDetails my-2"
          >
            <div>
              <div className="selected-flight-details__flight-leg_details d-flex gap-3">
                <div>
                  <AppFlightLogo
                    carrier={flightLeg.carrier.substring(0, 2)}
                    className="vertical-bottom"
                  />
                </div>
                <div className="d-flex flex-column text-uppercase fs-12 justify-content-center">
                  <div className="d-flex gap-2">
                    <span className="primary-color primaryDeptColor">
                      {flightLeg.validatingcarriername}
                    </span>
                    <span className="flightNumber">
                      {getFlightNumber(flightLeg.flightnumber, index)}
                    </span>
                    <span className="bookingClass">
                      BOOKING CLASS:{' '}
                      {getBookingClass(flightLeg.bookingclass, index)}
                    </span>
                    {/* {!isEmpty(selectedFlight.supplier) && !selectedFare && (
                      <span>SUPPLIER: {selectedFlight.supplier}</span>
                    )} */}
                  </div>
                  <div className="">
                    {selectedFare ? (
                      <div className="flightFareType">
                        {selectedFare.faretype}
                      </div>
                    ) : (
                      <div className="flightFareType">
                        {selectedFlight.flightfare.faretype}
                      </div>
                    )}
                  </div>
                  <div className="d-flex gap-2 flex-wrap flex-sm-row flex-column">
                    <span className="cabinClass">{flightLeg.cabinclass}</span>
                    <span className="aircraftType">
                      Aircraft Type: {flightLeg.equipment}
                    </span>
                    <span className="flightLeg">
                      {getOperatedBy(flightLeg)}
                    </span>
                  </div>
                </div>
              </div>
              <div className="selected-flight-details__flight-leg_departure my-3">
                <div className="d-flex align-items-center">
                  <img
                    src="/images/others/flight-details-line.svg"
                    alt=""
                    style={{ height: '50px' }}
                  />
                </div>
                <div className="d-flex flex-column">
                  <span className="dark-grey-color fs-14 fw-600 deptdetails stopDetails">{`${formatTimeString(
                    flightLeg.deptime,
                  )} (${formatDate(
                    getNewDate(flightLeg.depdate),
                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                  )}) - ${flightLeg.origin_name} ${getTerminalNumber(
                    flightLeg.depterminal,
                  )}`}</span>
                  <span className="fs-10 mb-2">
                    {getAirportNameByCode(flightLeg.origin)}
                  </span>
                  <span className="fs-12 grey-color mb-2">
                    {formattedMessage('travel_time')}:{' '}
                    {convertTravelTime(flightLeg.journeyduration)}
                  </span>
                  <span className="dark-grey-color fs-14 fw-600 arrDetails stopDetails">{`${formatTimeString(
                    flightLeg.arrtime,
                  )} (${formatDate(
                    getNewDate(flightLeg.arrdate),
                    DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                  )}) - ${flightLeg.destination_name} ${getTerminalNumber(
                    flightLeg.arrterminal,
                  )}`}</span>
                  <span className="fs-10">
                    {getAirportNameByCode(flightLeg.destination)}
                  </span>
                </div>
              </div>
              <div className="selected-flight-details__flight-leg_amenities">
                {/* <span>{formattedMessage('paid_meal')}</span> */}
                <span className="checkInWeight">
                  {formattedMessage('check_in')}:{' '}
                  {getFlightBaggage(
                    flightLeg.bagweight,
                    flightLeg.bagunit,
                    index,
                  )}
                </span>
                <span className="cabinWeight">
                  Cabin :{' '}
                  {getFlightBaggage(
                    flightLeg.cabinBagweight,
                    flightLeg.cabinBagunit,
                    index,
                  )}
                </span>
              </div>
              {flightLeg.transitvisainfo && (
                <div className="premium-color ps-2 mt-1 fw-600">
                  {flightLeg.transitvisainfo}
                </div>
              )}
            </div>

            {flightLeg.destination !== finalDestination && (
              <div className="selected-flight-details__flight-leg_layover py-1 my-2">
                <MdAccessTime />
                <span className="selected-flight-details__flight-leg_layover__location ms-1">
                  {getConnectingTime(
                    flightLeg.arrtime,
                    flightLeg.arrdate,
                    flightlegs[index + 1].deptime,
                    flightlegs[index + 1].depdate,
                  )}{' '}
                  {formattedMessage('layover_in')} {flightLeg.destination_name}
                </span>
              </div>
            )}
          </div>
        );
      })}
      {showTransitInfo && (
        <div className="fs-12 bg-warning-subtle px-2 py-1 border">
          <div className="fs-14">
            <b>*Visa Guidelines</b>
          </div>
          <div>
            Before You Book: Ensure a smooth journey by verifying the visa and
            transit visa regulations for your destination. You can find this
            information on the{' '}
            <a
              href="https://www.iatatravelcentre.com/"
              target="_blank"
              rel="noreferrer"
            >
              IATA
            </a>{' '}
            or by contacting the appropriate embassy.
          </div>
        </div>
      )}
    </section>
  );
}
SelectedFlightDetails.defaultProps = {
  isOnward: true,
  selectedFare: undefined,
};

SelectedFlightDetails.propTypes = {
  selectedFlight: PropTypes.object.isRequired,
  selectedFare: PropTypes.object,
  isOnward: PropTypes.bool,
};

export default SelectedFlightDetails;
